import { useMutation } from '@tanstack/react-query';

import { useRequest, getAnalyticsSettingsKey } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

import type {
  AnalyticsSettingsData,
  UpdateAnalyticsSettingsQueryVars,
  UseAnalyticsSettingsParams,
} from './types';

export const useUpdateAnalyticsSettings: MutationFunction<
  AnalyticsSettingsData,
  UpdateAnalyticsSettingsQueryVars,
  [UseAnalyticsSettingsParams]
> = (params, { requestOptions, queryOptions } = {}) => {
  const { groupId } = params;
  const urlPath = `/suppliers/${groupId}/analytics_settings`;
  const mutationKey = getAnalyticsSettingsKey(params);
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: (body) => {
      return request(urlPath, {
        init: {
          method: 'PUT',
          body,
        },
      });
    },
    ...queryOptions,
    mutationKey,
  });
};
